import { Color } from "three"
import type { Nullable } from "../../../../typescript"
import { isEntityDeadwood, isEntityDesert, isEntityForest, isEntityJungle, isEntityLake, isEntityMarsh, isEntityMountain, isEntityPlain, isEntityRiver, isEntitySea, isEntityShoal, isEntitySnow, isEntitySwamp } from "../../../core/entity/entityTypeMetaList.generated"
import type { Entity } from "../../../core/entity/index"
import { beachSand, deadwoodGround, debugPink, duneTan, forestFloor, grass, jungleFloor, lakeBed, marshMud, mountainRock1, oceanFloorMuddyGrayBlue, ridgeSnowCap, riverBasinSilt, swampMuck } from "./colors"

export default function getTerrainMesh1V2TileColor(ent: Nullable<Entity>): Readonly<Color> {
  if (ent) {
    if (isEntitySnow(ent)) {
      return ridgeSnowCap
    }
    if (isEntityPlain(ent)) {
      return grass
    }
    if (isEntityDesert(ent)) {
      return duneTan
    }
    if (isEntityRiver(ent)) {
      return riverBasinSilt
    }
    if (isEntitySea(ent)) {
      return oceanFloorMuddyGrayBlue
    }
    if (isEntityShoal(ent)) {
      return beachSand
    }
    if (isEntityForest(ent)) {
      return forestFloor
    }
    if (isEntityMarsh(ent)) {
      return marshMud
    }
    if (isEntitySwamp(ent)) {
      return swampMuck
    }
    if (isEntityLake(ent)) {
      return lakeBed
    }
    if (isEntityDeadwood(ent)) {
      return deadwoodGround
    }
    if (isEntityJungle(ent)) {
      return jungleFloor
    }
    if (isEntityMountain(ent)) {
      return mountainRock1
    }
    // console.log('getTerrainMesh1V2TileColor', entityDisplayName(ent), ent)
    return oceanFloorMuddyGrayBlue
  }
  return debugPink
}

